import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../config/config";
import axiosInstance from "../../../interceptors";

const post = (path) => (payload) => axiosInstance.post(`${baseUrl}/job-posting/api/candidate-portal${path}`, payload);

const make = (name, path) => createAsyncThunk(name, async (payload, { rejectWithValue }) => {
  try {
    const { data } = await post(path)(payload);
    if (data.success) return data.data;
    return rejectWithValue(data.message);
  } catch (error) { return rejectWithValue(error.message); }
});

export const cpDashboard = make("cp/dashboard", "/dashboard");
export const cpListNotifications = make("cp/notifications/list", "/notifications/list");
export const cpMarkNotificationRead = make("cp/notifications/markRead", "/notifications/mark-read");
export const cpListDocuments = make("cp/documents/list", "/documents/list");
export const cpAddDocument = make("cp/documents/add", "/documents/add");
export const cpDeleteDocument = make("cp/documents/delete", "/documents/delete");
export const cpListResources = make("cp/resources/list", "/resources/list");
export const cpListFeedback = make("cp/feedback/list", "/feedback/list");
export const cpSubmitFeedback = make("cp/feedback/submit", "/feedback/submit");
export const cpListPractice = make("cp/practice/list", "/practice/list");
export const cpRunPractice = make("cp/practice/run", "/practice/run");
export const cpGetProfile = make("cp/profile/get", "/profile/get");
export const cpLogActivity = make("cp/activity/log", "/activity/log");
export const cpListFaqs = make("cp/faqs/list", "/faqs/list");
